import { createFileRoute } from '@tanstack/react-router'

import AccessDenied from 'pages/AccessDenied'

export const Route = createFileRoute('/access-denied')({
  component: AccessDenied,
})
